// Replay retention is an account duty-policy value. Keep the allowlist and clamp outside the
// Replay desk so the policy mapper, Admin chips, and window resolver cannot drift.

/** Lock Q12 default: accounts keep a 30-day Replay calendar until an operator chooses less. */
export const REPLAY_RETENTION_DEFAULT_DAYS = 30;

/** The only values accepted by the policy CHECK and exposed by the Admin chips. */
export const REPLAY_RETENTION_ALLOWED_DAYS = [7, 14, 30] as const;

export type ReplayRetentionDays = (typeof REPLAY_RETENTION_ALLOWED_DAYS)[number];

/** Snap an arbitrary boundary value onto the allowed chips, failing safe to the default. */
export function replayRetentionDays(requested: number | null | undefined): ReplayRetentionDays {
  if (typeof requested !== "number" || !Number.isFinite(requested)) {
    return REPLAY_RETENTION_DEFAULT_DAYS;
  }
  let best: ReplayRetentionDays = REPLAY_RETENTION_DEFAULT_DAYS;
  let bestDistance = Number.POSITIVE_INFINITY;
  for (const allowed of REPLAY_RETENTION_ALLOWED_DAYS) {
    const distance = Math.abs(allowed - requested);
    // Ties go to the smaller window. Showing less history is honest; showing more would exceed
    // the account policy the desk is responsible for enforcing.
    if (distance < bestDistance || (distance === bestDistance && allowed < best)) {
      best = allowed;
      bestDistance = distance;
    }
  }
  return best;
}
